import { ref } from 'vue'

export interface Breadcrumb {
    label: string
    to?: string
}

const crumbs = ref<Breadcrumb[]>([])

export function useBreadcrumbs(items?: Breadcrumb[]) {
    if (items !== undefined) {
        crumbs.value = items
    }
    return { crumbs }
}
